const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;

if (!BASE_URL) {
  throw new Error("NEXT_PUBLIC_API_BASE_URL não definida");
}

export const fetchFromBase = (path: string, requestConfig?: RequestInit) =>
  fetch(`${BASE_URL}/${path}`, {
    ...requestConfig,
    credentials: "include",
    headers: {
      ...(requestConfig?.body ? { "Content-Type": "application/json" } : {}),
      "accept-language": "pt-br",
      // Força o uso do HTTP/1.1
      Connection: "keep-alive",
      "HTTP2-Settings": "disabled",
    },
  });
